import { NgModule } from '@angular/core';

import { PriceRangeCurrencyFormatterPipe } from '@shared/filters/pipes/price-range-currency-formatter.pipe';
import { RangeTypePipe } from '@shared/filters/pipes/range-type-format.pipe';
import { AssignObjectFilterValuePipe } from '@shared/filters/pipes/assign-filter-value.pipe';
import { AirSorterTabsPipe } from '@shared/filters/pipes/air-sorter-tabs.pipe';

@NgModule({
  declarations: [
    RangeTypePipe,
    PriceRangeCurrencyFormatterPipe,
    AssignObjectFilterValuePipe,
    AirSorterTabsPipe,
  ],
  exports: [
    RangeTypePipe,
    PriceRangeCurrencyFormatterPipe,
    AssignObjectFilterValuePipe,
    AirSorterTabsPipe,
  ],
  providers: [
    RangeTypePipe,
    PriceRangeCurrencyFormatterPipe,
    AssignObjectFilterValuePipe,
    AirSorterTabsPipe,
  ]
})
export class FilterPipesModule { }
